export default __webpack_public_path__ + "static/media/flow-goal.ff13495c.svg";